@if (showHeaders()) {
  <ds-header-wrapper></ds-header-wrapper>
}
<ds-loading-spinner></ds-loading-spinner>
<div [style.height]="mobileMenuOpen() && mobileMenuActive() ? '100%' : '0'" class="overlay"></div>
<div id="body-wrapper" class="flex row" [class.noDock]="noDock()">
  <div class="column twelve">
    <router-outlet></router-outlet>
  </div>
</div>

<ds-modal [id]="noDocumentModalId" [closeOthers]="true" [maxWidth]="300">
  <h3 class="font-weight-semibold" dsContent [contentPath]="noDocumentHeader()"></h3>
  <div class="no-documents-modal flex-1">
    <div class="margin-bottom-10">{{ noDocumentMessage() }}</div>
    <button
      ds-button
      [buttonVariant]="'primary'"
      data-cy="noDocumentModal"
      (click)="closeNoDocumentModal()"
      dsContent
      [contentPath]="'shared.ok_status'"
    ></button>
  </div>
</ds-modal>

@if (showFeatureFlagPanel) {
  @defer (on idle) {
    <ds-feature-flag-panel></ds-feature-flag-panel>
  }
}
